import { ref } from 'vue';

const buildProductOptionsModel = (productData) => {
    const items = productData.productSetItems ?? [];

    return [
        {
            options: productData.options,
            quantity: productData.quantity,
        },
        ...items.map(i => ({
            options: i.setItem.options,
            quantity: i.quantity,
        })),
    ];
};

// Keep the brackets: a missing priceModifier makes the term NaN, and `sum + x || 0` would
// then discard everything accumulated so far rather than skipping the one entry.
export const sumOptionModifiers = (options, quantity = 1) => {
    return options.reduce((sum, option) => sum + (option?.priceModifier || 0) * quantity, 0);
};

const selectedOptionValues = (options) => {
    return options.map(option => option.values.find(v => v.productOptionValueID === option.productOptionValueID));
};

const recalculateItemOptionModifier = (options, quantity) => {
    return sumOptionModifiers(selectedOptionValues(options), quantity);
};

const getProductOptionsModifiersValue = (productData) => {
    const productOptionsModel = buildProductOptionsModel(productData);
    return productOptionsModel.reduce((acc, curr) => {
        return acc + recalculateItemOptionModifier(curr.options, curr.quantity);
    }, 0);
};

export const useProductOptionsModifiers = () => {
    const priceWithOptionModifiers = ref(null);
    const effectivePriceWithOptionModifiers = ref(null);

    const updateProductOptionsModifiersValue = (productData) => {
        const modifiersValue = getProductOptionsModifiersValue(productData);
        priceWithOptionModifiers.value = productData.price + modifiersValue;
        effectivePriceWithOptionModifiers.value = productData.effectivePrice + modifiersValue;
    };

    return {
        priceWithOptionModifiers,
        effectivePriceWithOptionModifiers,
        getProductOptionsModifiersValue,
        updateProductOptionsModifiersValue,
    };
};
